import axios from 'axios';

export const API_BASE = axios.create({
  // baseURL: 'http://localhost:3000',
  headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')}
});
